import React from "react";
import { Link } from "react-router-dom";

import "./HomeArchiveStory.css";

const DEFAULT_STORY_IMAGE = "/images/home/academy-costumes.png";

export default function HomeArchiveStory({
  image = DEFAULT_STORY_IMAGE,
  imageAlt = "Archive garments, textiles and haberdashery details at Academy Costumes London",
}) {
  return (
    <section
      className="home-archive-story"
      aria-label="Explore Academy Costumes London"
    >
      <div className="home-archive-story__media">
        <img
          src={image}
          alt={imageAlt}
          className="home-archive-story__image"
          loading="lazy"
          decoding="async"
        />

        <div
          className="home-archive-story__links"
          aria-label="Explore Academy Costumes London"
        >
          <Link to="/services" className="home-archive-story__cta">
            Services
          </Link>

          <Link to="/made-to-measure" className="home-archive-story__cta">
            Made to Measure
          </Link>

          <Link to="/shop" className="home-archive-story__cta">
            Shop
          </Link>
        </div>
      </div>
    </section>
  );
}
